var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.11369 0.5625H4.92562L0.75 1.65V10.35L4.92562 11.4375H5.11369V0.5625Z",
    fill: "#2F47BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43337 6.37499L8.1875 7.25605L7.61769 7.74393L6.125 5.99999L7.61769 4.25605L8.1875 4.74392L7.43337 5.62499H11.2503V6.37499H7.43337Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10238 2.025H5.4885V9.225H4.7385V0.998625L1.125 1.93987V10.0601L4.7385 11.0014V9.975H9.10238V7.5H9.85238V10.725H5.4885V11.8125H4.87762L0.375 10.6399V1.36013L4.87762 0.1875H5.4885V1.275H9.85238V4.5H9.10238V2.025Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeave);
export default __webpack_public_path__ + "static/media/leave.4c6ab2ce1900324d60346a9a544e8d1d.svg";
export { ForwardRef as ReactComponent };